import { type ComponentPropsWithoutRef, useState } from "react";

import { Input as BaseInput } from "../ui/input";
import { cn } from "../lib/utils";

import { FieldError } from "./FieldError";
import Icon from "./Icon";

type InputProps = {
  iconName: string;
  error?: string;
} & ComponentPropsWithoutRef<"input">;

export function Input({ iconName, className, type = "text", error, onFocus, onBlur, ...props }: InputProps) {
  const isDateInput = type === "date";
  const [inputType, setInputType] = useState<string>(isDateInput ? "text" : type);

  return (
    <div className="w-full">
      <div className="group relative">
        <span
          className="pointer-events-none absolute inset-y-0 left-4 flex w-6 items-center justify-center text-muted-foreground transition-colors group-hover:text-primary"
          aria-hidden="true"
        >
          <Icon src={iconName} size={18} />
        </span>
        <BaseInput
          type={inputType}
          aria-invalid={error ? true : undefined}
          className={cn(
            "h-14 pl-12 bg-white text-[18px] placeholder:text-[18px] transition-all duration-200 border border-input hover:border-2 hover:border-[#699F11] hover:shadow-[0_15px_20px_0_rgba(0,0,0,0.15)] focus-visible:border-2 focus-visible:border-[#699F11] focus-visible:ring-0 focus-visible:shadow-[0_15px_20px_0_rgba(0,0,0,0.15)]",
            error &&
              "border-red-500 hover:border-red-500 focus-visible:border-red-500",
            className,
          )}
          onFocus={(e) => {
            if (isDateInput) setInputType("date");
            onFocus?.(e);
          }}
          onBlur={(e) => {
            if (isDateInput && !e.target.value) setInputType("text");
            onBlur?.(e);
          }}
          {...props}
        />
      </div>
      <FieldError message={error} />
    </div>
  );
}
